import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { WithLeaseShare } from 'site-modules/lease-deals/components/with-lease-share/with-lease-share';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';

import './share-button.scss';

export const ShareButton = ({ year, make, model, id, styleId, className = null }) => {
  return (
    <span className={classnames('d-flex align-items-center', className)}>
      <WithLeaseShare year={year} make={make} model={model} id={id} styleId={styleId}>
        {({ onShare, isSupported, title, imageSrc }) => {
          return (
            <button
              className="border-start border-top border-bottom border-end lease-deals-share-button pos-r bg-white rounded-pill p-0_5 px-1 lh-1 z-1 text-nowrap"
              onClick={onShare}
              aria-label="Share this deal"
              disabled={!isSupported}
              title={title}
            >
              <Image imageId={imageSrc} source={SOURCES.STATIC} width={20} height={20} ariaHidden lazy />
              <span className="ms-0_25 align-middle">Share</span>
            </button>
          );
        }}
      </WithLeaseShare>
    </span>
  );
};

ShareButton.propTypes = {
  styleId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  className: PropTypes.string,
};
